import { useState } from "react";
import { TileDeFato } from "../componentes/CalendarioUi";
import { Cabine } from "../componentes/FerramentaUi";
import { Secao } from "../componentes/PeritoUi";
import { hoje } from "../lib/perito/datas";
import { usePerito } from "../lib/perito/store";

// O que a conta tem na Central do Perito e a exportação (fase B), portados de
// `src/routes/_authenticated/configuracoes.tsx`. O arquivo é o `exportarJson` do store, o mesmo de lá: as
// perícias com os honorários, as tarefas, os prazos, o histórico que está em memória (as 500 ações mais
// recentes, as que `perito_ler` devolve), os filtros e a LISTA dos documentos — os arquivos ficam no bucket.

export default function PeritoMeusDados() {
  const { pericias, prazos, tarefas, documentos, exportarJson } = usePerito();
  const [baixado, setBaixado] = useState(false);
  const baixar = () => {
    const url = URL.createObjectURL(new Blob([exportarJson()], { type: "application/json" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `central-do-perito-meus-dados-${hoje()}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    setBaixado(true);
  };
  return (
    <div className="flex flex-col gap-5" data-meus-dados>
      <Cabine rotulo="Conta" titulo="Meus dados"
        descricao="Tudo o que você cadastra na Central do Perito fica na sua conta do hub e acompanha você em qualquer computador."
        fatos={
          <>
            <TileDeFato rotulo="Perícias" valor={<span data-fato="pericias">{pericias.length}</span>} />
            <TileDeFato rotulo="Prazos" valor={<span data-fato="prazos">{prazos.length}</span>} />
            <TileDeFato rotulo="Tarefas" valor={<span data-fato="tarefas">{tarefas.length}</span>} />
            <TileDeFato rotulo="Documentos" valor={<span data-fato="documentos">{documentos.length}</span>} />
          </>
        } />
      <div className="max-w-3xl">
        <Secao nome="exportar" titulo="Baixar meus dados" descricao="Um arquivo JSON com as perícias, os honorários, os prazos, as tarefas, os filtros salvos e o histórico recente.">
          <p className="text-sm leading-relaxed text-cinza">
            Os arquivos anexados às perícias não vão no arquivo, só a lista deles. O histórico vai com as 500 ações mais recentes.
          </p>
          <button type="button" onClick={baixar} className="pill-cta mt-4 inline-flex min-h-11 items-center px-5 text-sm" data-baixar-meus-dados>Baixar meus dados</button>
          {baixado && <p role="status" className="mt-3 text-sm text-aviso-tinta" data-baixado>O arquivo foi gerado. Confira a pasta de downloads do navegador.</p>}
        </Secao>
      </div>
    </div>
  );
}
